import React from 'react';
import { InstructionsWrapper, InstructionsBox } from './styles';
import { CommonButton } from '@Components';
import { ReferInstructionsProps } from '../interface';
import { connect } from 'react-redux';
import { activateLoader } from '../../../redux/actions/ui-trigger/ui-trigger-action';
import { ONE_ICON, THREE_ICON, TWO_ICON } from '@Images';
import {
  EVENT_ROUTE_KEYS,
  EventButtonType,
  EventNamesV2,
  FLOW_TYPE
} from '@Utils/events/eventsConstants';
import { logEventV2 } from '@Utils/events/logUserEvents';

const ReferInstructions: React.FC<ReferInstructionsProps> = ({
  onClose,
  labels,
  activateLoader
}): React.ReactElement => {
  const imageMap: Record<number, string> = {
    1: ONE_ICON,
    2: TWO_ICON,
    3: THREE_ICON
  };
  const workData = labels?.referralWorksModal;
  const shareData = labels?.shareData;

  const eventProperty = {
    type: EventButtonType.BUTTON,
    pageName: EVENT_ROUTE_KEYS.ReferAndEarn,
    ctaName: shareData?.termsConditionText,
    flowType: FLOW_TYPE.REFERRALS
  };
  return (
    <InstructionsWrapper>
      <InstructionsBox>
        <div className="instructionsHeader">
          <span className="worksText">{workData?.heading}</span>
          <span className="instructionText">{workData?.description}</span>
        </div>
        <div className="instructionBox">
          <div className="stepsBox">
            <div className="steps">
              {workData?.referralWorkSteps.map((step: any, index: any) => (
                <div className="index" key={index}>
                  <div className="stepPoints">
                    <img alt="numberIcon" src={imageMap[index + 1]} />
                    <span>{step}</span>
                  </div>
                  {index !== workData?.referralWorkSteps.length - 1 && (
                    <div className="separationLine"></div>
                  )}
                </div>
              ))}
            </div>
            <span className="conditions">
              <a
                className="linkText"
                href={labels?.tncLink}
                onClick={() => {
                  logEventV2(EventNamesV2.CTA_CLICKED, eventProperty);
                  activateLoader && activateLoader();
                }}
              >
                {shareData?.termsConditionText}
              </a>
            </span>
          </div>
        </div>
        <CommonButton
          height={46}
          width={410}
          onClick={() => onClose(false)}
          text={workData?.gotItBtnText}
        ></CommonButton>
      </InstructionsBox>
    </InstructionsWrapper>
  );
};

export default connect<any, any>(null, {
  activateLoader
})(ReferInstructions);
